import React from "react";

export const fromCapitalizedToOnlyFirstLetterCapitalized = (str: string) => {
    const lowerCaseStr = str.toLowerCase();
    return lowerCaseStr.charAt(0).toUpperCase() + lowerCaseStr.slice(1);
};

export const capitalizeFirstLetter = (str: string) => {
    return str.toUpperCase().charAt(0) + str.slice(1).toLowerCase();
}